// extracted by mini-css-extract-plugin
export default {"Wrapper":"_1lhVB5q3qQsq5mm0D-HpdQ=="};